import Highcharts from "highcharts";
// Import highcharts-more as a side-effect module (Highcharts v11+ syntax)
import "highcharts/highcharts-more";

// Configure global Highcharts options
Highcharts.setOptions({
  global: {
    useUTC: false
  },
  lang: {
    thousandsSep: ','
  },
  // Disable accessibility features that add extra labels
  accessibility: {
    enabled: false
  },
  // Chart-wide defaults to match production
  chart: {
    style: {
      fontFamily: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif'
    }
  },
  // Data label defaults
  plotOptions: {
    series: {
      dataLabels: {
        style: {
          fontFamily: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
          fontSize: '10px',
          fontWeight: 'normal',
          textOutline: 'none'
        }
      }
    },
    bubble: {
      // Remove default markers that might appear as "bubbles" on axes
      marker: {
        lineWidth: 0,
        lineColor: null
      }
    }
  },
  // X-axis defaults
  xAxis: {
    labels: {
      enabled: false,
      style: {
        fontFamily: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '11px'
      }
    }
  },
  // Y-axis defaults
  yAxis: {
    labels: {
      enabled: false,
      style: {
        fontFamily: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '11px'
      }
    }
  }
});

export default Highcharts; 